angular.module('aq.admin.productDesign').controller('HomeCtrl', function () {

});